// Application Windows (coque Electron, dossier desktop/ du dépôt).
//
// Dans la coque, le site tourne depuis app://ecarbu/ : son origine n'est
// joignable de nulle part ailleurs, et la coque expose `window.ecarbuDesktop`
// (voir desktop/src/preload.js). Sur le web, tout ce fichier est sans effet.

export const desktopBridge = () =>
  typeof window !== 'undefined' && window.ecarbuDesktop && window.ecarbuDesktop.isDesktop
    ? window.ecarbuDesktop
    : null;

export const isDesktop = () => Boolean(desktopBridge());

/**
 * Adresse publique du serveur: celle qu'on peut donner à un tiers (lien envoyé
 * à un client, URL de webhook d'un fournisseur GPS, flux temps réel). Sur le
 * web c'est l'origine de la page; dans la coque, celle du serveur.
 */
export const publicOrigin = () => {
  const pont = desktopBridge();
  if (pont && pont.serverOrigin) return String(pont.serverOrigin).replace(/\/+$/, '');
  return typeof window !== 'undefined' ? window.location.origin : '';
};

/**
 * Prévient la coque du nombre d'écritures encore à envoyer au serveur: elle ne
 * redémarre jamais pour une mise à jour tant qu'il y en a.
 */
export const signalerEcrituresEnAttente = (nombre) => {
  const pont = desktopBridge();
  if (!pont || typeof pont.reportPendingWrites !== 'function') return;
  try {
    pont.reportPendingWrites(nombre);
  } catch (erreur) {
    // Le signal est facultatif: jamais d'erreur visible pour lui.
  }
};
